import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MachineRoutingModule } from './machine-routing.module';
import { MachineComponent } from './machine.component';
import { EventsComponent } from './events/events.component';
import { LogsComponent } from './logs/logs.component';
import { OpenIssuesComponent } from './open-issues/open-issues.component';
import { SalesComponent } from './sales/sales.component';
import { UpdatesComponent } from './updates/updates.component';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from '../../../../app/core/core.module';
import { PartialsModule } from '../../partials/partials.module';

// Material
import {
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatProgressBarModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatCardModule,
	MatRadioModule,
	MatIconModule,
	MatDatepickerModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatSnackBarModule,
	MatTooltipModule,
	MatChip,
	MatChipsModule,
	MatDivider,
	MatDividerModule,
	MatExpansionModule,
	MatSlideToggleModule,
	MatButtonToggleModule
} from '@angular/material';
import { ModeWarnComponent } from './updates/update-dialogs/mode-warn.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { RemoteCtrlComponent } from './remote-ctrl/remote-ctrl.component';
import { MachineDetailsComponent } from './machine-details/machine-details.component';
import { SignalStrengthComponent } from './signal-strength/signal-strength.component';
import { ChartsModule } from 'ng2-charts';
import { ConnectionLogsComponent } from './connection-logs/connection-logs.component';
import { InventoryComponent } from './inventory/inventory.component';
import { InventoryDialogComponent } from './inventory/inventory-dialog/inventory-dialog.component';
import { InventoryLocationComponent } from './inventory-location/inventory-location.component';
import { MachineSelectionDialogComponent } from './machine-details/machine-selection-dialog/machine-selection-dialog.component';
import { CardReaderComponent } from './card-reader/card-reader.component';
import { SettingsComponent } from './settings/settings.component';
import { ShadowSettingsComponent } from './settings/shadow-settings/shadow-settings.component';
import { CalibSettingsComponent } from './settings/calib-settings/calib-settings.component';
import { OiDialogsComponent } from './open-issues/oi-dialogs/oi-dialogs.component';
import { PriceChangeComponent } from './price-change/price-change.component';
import { MachineColdBrewComponent } from './cold-brew/machine-cold-brew.component';
import { AugerPurgeComponent } from './auger-purge/auger-purge.component';
import { AugerPurgeConfirmDialogComponent } from './auger-purge/auger-purge-confirm-dialog.component';
import { CanisterTypeComponent } from './canister-type/canister-type.component';
import { CanisterTypeConfirmDialogComponent } from './canister-type/canister-type-confirm-dialog.component';
import { RestocksComponent } from './restocks/restocks.component';
import { CameraHistoryDialogComponent } from './inventory/camera-history-dialog/camera-history-dialog.component';
import { NgApexchartsModule } from 'ng-apexcharts';

@NgModule({
  imports: [
	FormsModule,
	ReactiveFormsModule,
	CommonModule,
	MachineRoutingModule,
	NgbModule,
	HttpClientModule,
	CoreModule,
	PartialsModule,
	MatDialogModule,
	MatButtonModule,
	MatMenuModule,
	MatSelectModule,
	MatChipsModule,
	MatDividerModule,
	MatInputModule,
	MatTableModule,
	MatAutocompleteModule,
	MatRadioModule,
	MatIconModule,
	MatNativeDateModule,
	MatProgressBarModule,
	MatDatepickerModule,
	MatCardModule,
	MatPaginatorModule,
	MatSortModule,
	MatCheckboxModule,
	MatProgressSpinnerModule,
	MatSlideToggleModule,
	MatButtonToggleModule,
	MatExpansionModule,
	MatSnackBarModule,
	MatTabsModule,
	ChartsModule,
	MatTooltipModule,
	OwlDateTimeModule,
	OwlNativeDateTimeModule,
	NgApexchartsModule,
  ],
  declarations: [
	  MachineComponent,
	  EventsComponent,
	  RemoteCtrlComponent,
	  LogsComponent,
	  OiDialogsComponent,
	  OpenIssuesComponent,
	  SalesComponent,
	  UpdatesComponent,
	  ModeWarnComponent,
	  MachineDetailsComponent,
	  CardReaderComponent,
	  SignalStrengthComponent,
	  ConnectionLogsComponent,
	  InventoryComponent,
	  InventoryDialogComponent,
	  InventoryLocationComponent,
	  MachineSelectionDialogComponent,
	  SettingsComponent,
	  ShadowSettingsComponent,
	  CalibSettingsComponent,
	  PriceChangeComponent,
	  MachineColdBrewComponent,
	  AugerPurgeComponent,
	  AugerPurgeConfirmDialogComponent,
	  CanisterTypeComponent,
	  CanisterTypeConfirmDialogComponent,
	  RestocksComponent,
	  CameraHistoryDialogComponent
  ],
  entryComponents: [
	ModeWarnComponent,
	InventoryDialogComponent,
	MachineSelectionDialogComponent,
	OiDialogsComponent,
	AugerPurgeConfirmDialogComponent,
	CanisterTypeConfirmDialogComponent,
	CameraHistoryDialogComponent
  ],
  providers: [
  ],
  exports: [
	InventoryLocationComponent
  ]
})

export class MachineModule {
}
